import {useContext} from 'react'
import SessionContext from '@helpers/auth/SessionContext'

export default function useSession() {
  return useContext(SessionContext)
}
